module.exports = __webpack_public_path__ + "img/ocr-example.png";